export default __webpack_public_path__ + "static/media/news.334790ab.png";